/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ui_Laps_Pill_OtherInputs */

const en_ui_laps_pill_other = /** @type {(inputs: Ui_Laps_Pill_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} device laps`)
};

const de_ui_laps_pill_other = /** @type {(inputs: Ui_Laps_Pill_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Geräterunden`)
};

/**
* | output |
* | --- |
* | "{count} device laps" |
*
* @param {Ui_Laps_Pill_OtherInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_pill_other = /** @type {((inputs: Ui_Laps_Pill_OtherInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Pill_OtherInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_pill_other(inputs)
	return de_ui_laps_pill_other(inputs)
});